import { App } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";

export const getCurrentPlatform = (): string => Capacitor.getPlatform();

export const isIosPlatform = (): boolean => Capacitor.getPlatform() == "ios";

export const isAndroidPlatform = (): boolean =>
  Capacitor.getPlatform() == "android";

export const isNativePlatform = (): boolean => Capacitor.isNativePlatform();

export const isAppInForeground = async (): Promise<boolean> => {
  const { isActive } = await App.getState();
  return isActive;
};
